import { render, staticRenderFns } from "./prontuarios_new.vue?vue&type=template&id=4f90323f&scoped=true"
import script from "./prontuarios_new.vue?vue&type=script&lang=js"
export * from "./prontuarios_new.vue?vue&type=script&lang=js"
import style0 from "./prontuarios_new.vue?vue&type=style&index=0&id=4f90323f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f90323f",
  null
  
)

export default component.exports